
const state= {
    cargues: [],
    loading: false,
}

export default state